export enum LogTypes {
    info = 'info',
    debug = 'debug',
    error = 'error',
    warn = 'warn',
}

export interface Logger {
    log: (type: LogTypes, entry: string, customData?: Object) => void;
    debug: (message: string, customData?: Object) => void;
    info: (message: string, customData?: Object) => void;
    warn: (message: string, customData?: Object) => void;
    /**
     * When logging error objects within customData, the props need to be picked:
     ```
     {
        error: {
            message: error.message,
            stack: error.stack,
            name: error.name,
        },
     }
     ```
     * Otherwise the error will simply get lost and not show up in Kibana.
     */
    error: (error: string, customData?: Object) => void;
}
